import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AiFillHome } from "react-icons/ai";

function ZoyaAI(props) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // goes back to previous route
    // or use navigate("/dashboard"); to go to a specific page
  };

  const [isDownloaded, setIsDownloaded] = useState(false);

  useEffect(() => {
    if (props.components_list.includes("search-contacts-export")) {
      setIsDownloaded(true);
    } else {
      setIsDownloaded(false);
    }
  }, [props.components_list]);
  return (
    props.components_list.includes("zoya-ai-iframe") && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          border: "none",
          margin: 0,
          padding: 0,
          overflow: "hidden",
          zIndex: 9999,
        }}
      >
        {/* Back Button */}
        <button
          onClick={handleBack}
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            zIndex: 10000,
            background: "linear-gradient(135deg, #ff8c42, #ff5722)",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            padding: "10px 16px",
            fontWeight: "600",
            cursor: "pointer",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
          }}
        >
          <AiFillHome size={15} /> Dashboard
        </button>

        {/* Iframe */}
        <iframe
          src={`https://pdhanewala.com:4002?AUTH_ID=${props.auth_id}&DOWNLOAD=${isDownloaded}`}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
          title="Zoya AI"
        />
      </div>
    )
  );
}

const mapStateToProps = (state) => ({
  auth_id: state.contactData.auth_id,
  components_list: state.contactData.components_list,
});

export default connect(mapStateToProps)(ZoyaAI);
